export const TITLE = "Windmill | Your AI Manager Assistant";

export const DESCRIPTION = "Management hasn't changed in decades. It's time for a new approach.";

export const OG_IMAGE =
  "https://windmill-storage-prod.s3.us-east-1.amazonaws.com/marketing/windmill-og-image-2.png";
